import React from 'react';
import {
  Grid,
  IconButton,
  Divider,
  colors,
  makeStyles,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Edit } from '@material-ui/icons';

import Title from 'components/typography/Title';
import ErrorMessage from 'components/typography/ErrorMessage';

const useStyles = makeStyles({
  editButton: {
    color: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
});

const RecipesMenuField = ({
  children,
  errorMessage,
  fieldTitle,
  editRoute,
}) => {
  const classes = useStyles();

  return (
    <Grid container direction="column" spacing={3}>
      <Grid item container alignItems="center">
        <Grid item style={{ flexGrow: 1 }}>
          <Title>{fieldTitle}</Title>
        </Grid>
        <Grid item>
          <Link to={editRoute}>
            <IconButton className={classes.editButton}>
              <Edit fontSize="small"></Edit>
            </IconButton>
          </Link>
        </Grid>
      </Grid>
      {children && <Grid item>{children}</Grid>}
      {errorMessage && (
        <Grid item>
          <ErrorMessage>{errorMessage}</ErrorMessage>
        </Grid>
      )}
      <Grid item>
        <Divider></Divider>
      </Grid>
    </Grid>
  );
};

export default RecipesMenuField;
